import { QueryResource } from '@/lib/datx-jsonapi-react';
import { Session } from '@/resources/Session';

export const queryUserSession = (id: string): QueryResource<Session> => {
  return id ? [Session, id, { include: ['user', 'main_profile'] }] : null;
};
